export const ITEM_ENTITY_TYPE = {
  rocks: 'rock',
  issues: 'issue',
  todos: 'todo',
  kpis: 'scorecard',
  headlines: 'headline',
} as const;

export type MeetingPrepItemKey = keyof typeof ITEM_ENTITY_TYPE;

export const MEETING_PREP_CTA_ID_BY_ITEM = {
  kpis: 'scorecard',
  rocks: 'rocks',
  headlines: 'headlines',
  todos: 'todos',
  issues: 'issues',
} as const satisfies Record<MeetingPrepItemKey, string>;

export type MeetingPrepCtaId = (typeof MEETING_PREP_CTA_ID_BY_ITEM)[MeetingPrepItemKey];
